const buildRecentSearchesImpressionLabel = recentSearches => {
  const eventLabelObject = {
    recent_search_rental: [],
    recent_search_sale: [],
    saved_search_rental: [],
    saved_search_sale: []
  };

  recentSearches.forEach((search, index) => {
    if (index > 2) return;

    if (search.title.toLowerCase().includes("rentals")) {
      if (search.isSaved) {
        eventLabelObject.saved_search_rental.push(search.id);
      } else {
        eventLabelObject.recent_search_rental.push(search.id);
      }
    } else if (search.isSaved) {
      eventLabelObject.saved_search_sale.push(search.id);
    } else {
      eventLabelObject.recent_search_sale.push(search.id);
    }
  });

  return Object.entries(eventLabelObject)
    .reduce((labels, [key, value]) => {
      if (value.length > 0) labels.push(`${key}=${value.join(",")}`);

      return labels;
    }, [])
    .join("|");
};

export default buildRecentSearchesImpressionLabel;
